import ReservationInspector, {
  type ReservationInspectorHandle,
} from '@/features/reservations/components/ReservationInspector';
import { useT } from '@/i18n';
import { Link as F7Link, NavLeft, NavRight, NavTitle, Navbar, Page } from 'framework7-react';
import { useRef } from 'react';

/**
 * Phone-only push-navigation page for a single reservation. On wide layouts
 * the inspector is docked into the workspace's right pane and this route is
 * unreachable from the UI; we keep it for deep links (`/reservations/:id`)
 * and for iOS-native push transitions out of the list.
 *
 * All the actual detail UI lives in `<ReservationInspector>` so the docked
 * pane and the pushed page render the exact same content. The Edit action is
 * hosted here as the navbar's trailing button and drives the inspector (which
 * owns the loaded reservation + edit popup) through its imperative handle.
 */
export default function ReservationDetailPage({
  f7route,
}: {
  f7route: { params: { id: string } };
}) {
  const t = useT();
  const inspectorRef = useRef<ReservationInspectorHandle>(null);
  return (
    <Page name="reservation-detail">
      <Navbar>
        <NavLeft>
          <F7Link back>{t.back}</F7Link>
        </NavLeft>
        <NavTitle>{t.reservations.detailTitle}</NavTitle>
        <NavRight>
          <F7Link onClick={() => inspectorRef.current?.openEdit()}>{t.edit}</F7Link>
        </NavRight>
      </Navbar>
      <ReservationInspector ref={inspectorRef} reservationId={f7route.params.id} />
    </Page>
  );
}
